/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The type of the cloud account
*/
export enum GcpNetworkType {
  GCP_NETWORK_TYPE_UNSPECIFIED = 'UNSPECIFIED',
  GCP_NETWORK_TYPE_PUBLIC = 'PUBLIC',
  GCP_NETWORK_TYPE_PRIVATE = 'PRIVATE'
}
